// extracted by mini-css-extract-plugin
export default {"tags":"xVms2SEr","desktop":"MCV6J7XI","tag":"qVhqmgI1","divider":"zwI1Laqk","letter":"th3UoQ82"};